import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchTerm, onSearchChange, placeholder = "Search case studies..." }) => {
  return (
    <div className="relative mb-6">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Icon name="Search" size={20} className="text-text-secondary" />
      </div>
      <Input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e?.target?.value)}
        className="pl-10 pr-4 py-3 w-full bg-card border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-200"
      />
      {searchTerm && (
        <button
          onClick={() => onSearchChange('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center hover:text-accent transition-colors duration-200"
        >
          <Icon name="X" size={20} className="text-text-secondary" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;